import environments from "../../../../environments";
import { ILayers } from "../../../../shared/interfaces/ILayers";
import { IWeGeoLegends } from "../../../../shared/interfaces/ILegends";
import {
    IGrpZoneamento,
    IProperty,
    IPropertyGeom,
} from "../../../../shared/interfaces/IProperties";
import { AraucariaZoneamento } from "./providers/araucaria";
import { ZoneamentoIpiranga } from "./providers/ipiranga";
import { ZoneamentoPalmeira } from "./providers/palmeira";
import { StandardZoneamento } from "./providers/standard";

interface Props {
    propertyInfo?: IProperty;
    propertyGeom?: IPropertyGeom;
    layers?: ILayers[];
    legends?: IWeGeoLegends[];
    zoneamentos?: IGrpZoneamento[];
}

export const Zoneamento: React.FC<Props> = ({
    propertyInfo,
    propertyGeom,
    layers,
    legends,
    zoneamentos,
}) => {
    switch (environments.client.name) {
        case "palmeira":
            return (
                <ZoneamentoPalmeira
                    propertyInfo={propertyInfo}
                    propertyGeom={propertyGeom}
                    layers={layers}
                    legends={legends}
                />
            );
        case "ipiranga":
            return (
                <ZoneamentoIpiranga
                    propertyInfo={propertyInfo}
                    propertyGeom={propertyGeom}
                    layers={layers}
                />
            );
        case "araucaria":
            return (
                <AraucariaZoneamento
                    propertyInfo={propertyInfo}
                    propertyGeom={propertyGeom}
                    layers={layers}
                    zoneamentos={zoneamentos}
                />
            );
        default:
            return (
                <StandardZoneamento
                    propertyInfo={propertyInfo}
                    propertyGeom={propertyGeom}
                    layers={layers}
                />
            );
    }
};
